import { TYPE_INFERENCE_OBJECT } from "../../Shared/Constants/Pointers";
var declareFeatureEventsType = function () {
    return TYPE_INFERENCE_OBJECT;
};
export { declareFeatureEventsType };
//# sourceMappingURL=declareFeatureEventsType.js.map